var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.scroll
    ? _c("w-container", [_vm._t("default")], 2)
    : _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [_vm._t("default")],
        2
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }